module.exports = __webpack_public_path__ + "img/norge.5c588e9f.png";